<template>
  <div id="container">
    <div class="box_one" style="margin-bottom:5px">
      <cont-top/>
    </div>

    <div class="main" style="margin-bottom:5px">
      <div class="title">
        <div class="title_name"></div>
      </div>

      <div class="clear">
        <el-image
          style="height:725px;width:1px;float:left;margin-right:24px;margin-left:167px"
          :src="require('@/assets/image/moment/newsActivities/img3.png')"
          :fit="cover">
        </el-image>
        <div style="width:660px ;float:left">
          <router-link to="2023-04-19" tag="div" append>
            <div class="line">
              <div class="line_item"> Team DIXCEL邀请您参与超吉联赛PRO! </div>
              <div> 2023-04-19 </div>
            </div>
          </router-link>
          <router-link to="2023-04-17" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国佛山分仓投入试运营!华南地区当日到货、次日到货成为现实! </div>
              <div> 2023-04-17 </div>
            </div>
          </router-link>
          <router-link to="2022-09-23" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国价格调整通知 </div>
              <div> 2022-09-23 </div>
            </div>
          </router-link>
          <router-link to="2021-11-01" tag="div" append>
            <div class="line">
              <div class="line_item"> 双十一狂欢！DIXCEL中国十周年感恩回馈！ </div>
              <div> 2021-11-01 </div>
            </div>
          </router-link>

          <router-link to="2021-05-31" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国618年中钜惠，全场钜惠8.8折等你来！ </div>
              <div> 2021-05-31 </div>
            </div>
          </router-link>

          <router-link to="2021-04-25" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL携手超吉联赛特别涂装赛车登陆上海车展 ，致敬吉利创业35周年 </div>
              <div> 2021-04-25 </div>
            </div>
          </router-link>

          <router-link to="2021-04-20" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国出展2021九州汽车生态展！ </div>
              <div> 2021-04-20 </div>
            </div>
          </router-link>

          <router-link to="2021-03-01" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国10周年logo发布！ </div>
              <div> 2021-03-01 </div>
            </div>
          </router-link>

          <router-link to="2019-11-30" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL携新品参展2019CAS改装展 </div>
              <div> 2019-11-30 </div>
            </div>
          </router-link>
          <router-link to="2019-06-20" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL（中国）产品价格调整通知 </div>
              <div> 2019-06-20 </div>
            </div>
          </router-link>
          <router-link to="2018-12-26" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国关于整顿闲鱼的声明 </div>
              <div> 2018-12-26 </div>
            </div>
          </router-link>
          <router-link to="2018-06-16" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL中国关于打击假冒伪劣产品的声明 </div>
              <div>2018-06-16 </div>
            </div>
          </router-link>
          <router-link to="2018-05-21" tag="div" append>
            <div class="line">
              <div class="line_item"> D1GP北京内海彰乃以2档勇夺追走亚军！ </div>
              <div>2018-05-21</div>
            </div>
          </router-link>
          <router-link to="2018-04-02" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL携手盛行汽车参加2018苏州GT SHOW </div>
              <div>2018-04-02</div>
            </div>
          </router-link>
          <router-link to="2017-09-23" tag="div" append>
            <div class="line">
              <div class="line_item"> 赢响力品牌中国行上海站</div>
              <div>2017-09-23</div>
            </div>
          </router-link>
          <router-link to="2017-06-23" tag="div" append>
            <div class="line">
              <div class="line_item">【全球首发】千呼万唤始出来！DIXCEL卡钳横空出世！</div>
              <div>2017-06-23</div>
            </div>
          </router-link>
          <router-link to="2017-03-28" tag="div" append>
            <div class="line">
              <div class="line_item">DIXCEL参加2017 GT Show国际改装风尚秀</div>
              <div>2017-03-28</div>
            </div>
          </router-link>
          <router-link to="2017-03-21" tag="div" append>
            <div class="line">
              <div class="line_item">DIXCEL成为2017宝珀亚洲GT官方合作伙伴</div>
              <div>2017-03-21</div>
            </div>
          </router-link>
          <router-link to="2016-12-09" tag="div" append>
            <div class="line">
              <div class="line_item"> DIXCEL（中国）整顿电商声明 </div>
              <div>2016-12-09</div>
            </div>
          </router-link>
          <router-link to="2016-03-30" tag="div" append>
            <div class="line">
              <div class="line_item">DIXCEL刹车皮/碟查询适配系统正式上线！</div>
              <div>2016-03-30</div>
            </div>
          </router-link>
          <router-link to="2013-09-11" tag="div" append>
            <div class="line">
              <div class="line_item">DIXCEL参加2013China Auto Salon上海国际改装车展</div>
              <div>2013-09-11</div>
            </div>
          </router-link>
          <router-link to="2013-07-19" tag="div" append>
            <div class="line">
              <div class="line_item">DIXCEL联合ChinaAutoSalon举办DIXCEL赴日车模选拔</div>
              <div>2013-07-19</div>
            </div>
          </router-link>
          <router-link to="2013-06-17" tag="div" append>
            <div class="line">
              <div class="line_item">SuperGT Rd3马来西亚站GAINER DIXCEL SLS获得季军</div>
              <div>2013-06-17</div>
            </div>
          </router-link>
          <router-link to="2013-05-17" tag="div" append>
            <div class="line">
              <div class="line_item">青年冠军方程式系列赛开幕</div>
              <div>2013-05-17</div>
            </div>
          </router-link>
          <router-link to="2013-05-16" tag="div" append>
            <div class="line">
              <div class="line_item">2013年大众汽车中国赛尚酷R杯开幕</div>
              <div>2013-05-16</div>
            </div>
          </router-link>
          <router-link to="2013-05-09" tag="div" append>
            <div class="line">
              <div class="line_item">中国首台改装86——谦毅86采用DIXCEL Ztype 0-850度高性能刹车皮！</div>
              <div>2013-05-09</div>
            </div>
          </router-link>
          <router-link to="2013-04-25" tag="div" append>
            <div class="line">
              <div class="line_item">PoloCupChina连续第三年使用DIXCEL刹车皮、碟</div>
              <div>2013-04-25</div>
            </div>
          </router-link>
          <router-link to="2013-04-07" tag="div" append>
            <div class="line">
              <div class="line_item">2013SuperGT(GT300)冈山揭幕战GAINER DIXCEL SLS获得冠军！</div>
              <div>2013-04-07</div>
            </div>
          </router-link>
        </div>
        <!-- <el-image
          style="height:701px;width:512px;float:left;"
          :src="require('@/assets/image/moment/newsActivities/img4.png')"
          :fit="fit">
        </el-image>
        <el-image
          style="height:701px;width:469px;float:left;margin-left:-336px;margin-top:1px"
          :src="require('@/assets/image/moment/newsActivities/img5.png')"
          :fit="fit">
        </el-image>

        -->


      </div>

      <!-- <div style="height:15px;width:408px;margin:0 auto;margin-top:37px">
        <el-image
          style="height:15px;width:408px;"
          :src="require('@/assets/image/moment/newsActivities/img21.png')"
          fit="contain">
        </el-image>
      </div> -->

    </div>

    <div class="box_bottom" >
      <cont-bottom/>
    </div>

  </div>
</template>

<script>
import ContTop from './Cont_top'
import ContBottom from '@/views/Components/Cont_bottom'


export default {
  data() {
    return {
      fit : 'contain'
    }
  },
  components : {
    ContTop ,
    ContBottom ,
  }
}

</script>

<style lang="stylus" scoped>
.clear:after {
  display: block;
  clear: both;
  content: '';
}

#container
  background-color : #000
  .box_one
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 0 52px;

}


.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/moment/newsActivities/img1.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 23px 56px 24px 57px;
  box-sizing: border-box;
}

.title_name {
  width: 57px;
  height: 61px;
  background: url('~@/assets/image/moment/newsActivities/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.line{
  display flex
  border-bottom:1px solid #000
  margin-bottom 10px
  cursor pointer
}
 .line_item {
   flex : 1;
   line-height 24px
 }

</style>
